export const PILLARS = [
  { name: 'Rest', type: 'rest', checked: false, disabled: false },
  { name: 'Nourish', type: 'nourish', checked: false, disabled: false },
  { name: 'Move', type: 'move', checked: false, disabled: false },
  { name: 'Connect', type: 'connect', checked: false, disabled: false },
  { name: 'Grow', type: 'grow', checked: false, disabled: false },
  { name: 'Reflect', type: 'reflect', checked: false, disabled: false }
];
